<script>

export default {
  props: {
    contact: {type: Object, required: true},
  },

  computed: {
    directChannel() {
      return this.$storage.getDirectChannel(this.contact.uuid)
    },
    isSpeaker() {
      return this.contact.speaker?.sessions?.length > 0
    },
    isModerator() {
      return this.contact.speaker?.sessions_chaired?.length > 0
    },
  },

  methods: {
    displayName(contact) {
      return `${contact.last_name || ''} ${contact.first_name || ''}`.trim() || contact.username
    }
  }
}

</script>

<template>

  <div class="list-group-item">
      <div class="d-flex flex-row align-items-center">
        <img :src="contact.profile_image" class="avatar me-2" />
        <div class="flex-fill">
          <h4 class="card-title mb-0">
            {{displayName(contact)}}
          </h4>
          <div v-if="contact.job_title" class="text-muted">
            <small>{{contact.job_title}}</small>
          </div>
          <div v-if="contact.company_name" class="text-muted">
            <small>{{contact.company_name}}</small>
          </div>
        </div>
        <div class="d-flex align-items-center gap-1">
          <span v-if="isSpeaker" class="badge bg-secondary">Speaker</span>
          <span v-if="isModerator" class="badge bg-warning text-dark">Moderator</span>
          <span v-if="directChannel && directChannel.numUnreadMessages"
           class="badge bg-danger">
            <i class="far fa-envelope"></i> {{directChannel.numUnreadMessages}}
          </span>
        </div>
      </div>
  </div>

</template>

<style scoped>

.avatar {
  height:30px;
  width:30px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}

.badge {
  border-radius: .5rem;
  height: fit-content;
}

</style>